"use strict";
import React, {
  useRef,
  useContext,
  forwardRef,
  useImperativeHandle
} from "react";
import { OptionMenuContext } from "./OptionMenu";
import { Delete } from "../../icons";
import { OptionMenuItemsContext } from "./OptionMenuItemsContext";
import { useLayoutEffect } from "../../../utils/useIsomorphicLayoutEffect";
import { MenuItem } from "../MenuItem/MenuItem";
const OptionMenuItemComponent = ({
  closeOnClick = true,
  disabled,
  onClick,
  destructive,
  selected,
  icon,
  endElement,
  className,
  children,
  innerRef,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  ["aria-describedby"]: ariaDescribedBy
}) => {
  const menuItemRef = useRef(null);
  useImperativeHandle(
    innerRef,
    // The ref is non-null by the time this function is run, but Typescript doesn't know that.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    () => menuItemRef.current
  );
  const { registerMenuItem, unregisterMenuItem, menuRef } = useContext(OptionMenuItemsContext);
  const { close, buttonRef } = useContext(OptionMenuContext);
  useLayoutEffect(() => {
    if (!disabled) {
      registerMenuItem(menuItemRef);
    }
    return () => {
      unregisterMenuItem(menuItemRef);
    };
  }, [disabled]);
  const handleClick = (event) => {
    if (closeOnClick) {
      close?.();
    }
    if (event.nativeEvent.detail === 0 && closeOnClick) {
      buttonRef.current?.focus();
    }
    onClick?.(event);
  };
  const handleMouseUp = () => {
    menuRef.current?.focus();
  };
  return /* @__PURE__ */ React.createElement(
    MenuItem,
    {
      className,
      ref: menuItemRef,
      onMouseUp: handleMouseUp,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
      onClick: !disabled ? handleClick : void 0,
      "aria-describedby": ariaDescribedBy,
      disabled,
      startElement: destructive ? icon || /* @__PURE__ */ React.createElement(Delete, null) : icon,
      endElement,
      selected,
      destructive,
      role: selected !== void 0 ? "menuitemradio" : "menuitem"
    },
    children
  );
};
const OptionMenuItem = forwardRef(function button(props, ref) {
  return /* @__PURE__ */ React.createElement(OptionMenuItemComponent, { innerRef: ref, ...props });
});
export default OptionMenuItem;
